import {KEY} from '@/constants/pcConstAppData';
import {PRESSURE_TYPE} from '@/constants/pressureContentConstant';
import {RUN_TIME_MODE} from '@/constants/sequenceContentConstants';
import * as setupActionsType from '@/constants/setupActionsType';
import {AppHelper} from '@/libs/appHelper';
import {IsNumber} from '@/libs/typeHelper';

/**
 * setup initial value for configuration
 * @deprecated redundant between {@link setupActionsType.INIT_VALUE} and {@link setupActionsType.UPDATE_ALL_VALUE}, maybe it should re-assign with the initial state value
 */
export function initValue(value) {
  return {
    type: setupActionsType.INIT_VALUE,
    value,
  };
}

/**
 * @param {Boolean} value
 * @returns
 */
export function updateIsManualProfileRunning(value) {
  return {
    type: setupActionsType.UPDATE_IS_MANUAL_PROFILE_RUNNING,
    value,
  };
}

/**
 * @param {Boolean} value
 * @returns
 */
export function updateIsManualProfilePaused(value) {
  return {
    type: setupActionsType.UPDATE_IS_MANUAL_PROFILE_PAUSED,
    value,
  };
}

export function updateDialfiltrationStatus(value) {
  return {
    type: setupActionsType.UPDATE_DIAFILTRATION_STATUS,
    value,
  };
}

export function updateShowRefillBuffer(value) {
  return {
    type: setupActionsType.UPDATE_SHOW_REFILL_BUFFER,
    value,
  };
}

export function updateShowThresholdError(value) {
  return {
    type: setupActionsType.UPDATE_SHOW_THRESHOLD_ERROR,
    value,
  };
}

/**
 * @param {Object} value
 * @param {Boolean} value.isPCRunning
 * @returns
 */
export function runProteinConcentrator(value) {
  return {
    type: setupActionsType.RUN_PROTEIN_CONCENTRATOR,
    value,
  };
}
/**
 * @param {Object} value
 * @param {String} value.deviceVersion
 * @returns
 */

export function saveDeviceVersion(value) {
  AppHelper.version = value;
  return {
    type: setupActionsType.SAVE_DEVICE_VERSION,
    value,
  };
}

/**
 * @param {Object} value
 * @param {Boolean} value.isPCPaused
 * TODO: the errorMessage property is unavailable anymore
 * @param {String} value.errorMessage
 */
export function pauseProteinConcentrator(value) {
  return {
    type: setupActionsType.PAUSE_PROTEIN_CONCENTRATOR,
    value,
  };
}
export function updateDiaphragmVacuumPressure(value) {
  return {
    type: setupActionsType.UPDATE_DIAPHRAGM_VACUUM_PRESSURE,
    value,
  };
}
export function updateDiaphragmPressure(value) {
  return {
    type: setupActionsType.UPDATE_DIAPHRAGM_PRESSURE,
    value,
  };
}
export function updateDiaphragmTiming(value) {
  return {
    type: setupActionsType.UPDATE_DIAPHRAGM_TIMING,
    value,
  };
}
export function updateValveTiming(value) {
  return {
    type: setupActionsType.UPDATE_VALVE_TIMING,
    value,
  };
}
export function updateShowWarning(value) {
  return {
    type: setupActionsType.UPDATE_SHOW_WARNING,
    value,
  };
}
export function autoCalibrate(value) {
  return {
    type: setupActionsType.AUTO_CALIBRATE,
    value,
  };
}
export function resetToDefault(value) {
  return {
    type: setupActionsType.RESET_TO_DEFAULT,
    value,
  };
}
export function checkProfileParam(value) {
  return {
    type: setupActionsType.CHECK_PROFILE_PARAM,
    value,
  };
}
//-------------------------------------------------------
// Status
//-------------------------------------------------------
/**
 *
 * @param {DEVICE_STATE} value {@link DEVICE_STATE}
 * @returns
 */
export function updatePCState(value) {
  return {
    type: setupActionsType.UPDATE_PC_STATE,
    value,
  };
}

//-------------------------------------------------------
// Status Progress Bar
//-------------------------------------------------------
/**
 * @param {Number} value
 * @returns
 */
export function updatePercentageProgressBar(value) {
  return {
    type: setupActionsType.UPDATE_PERCENTAGE_PROGRESS_BAR,
    value,
  };
}
export function updateEstimateTime(value) {
  return {
    type: setupActionsType.UPDATE_ESTIMATE_TIME,
    value,
  };
}
export function updateProgressBarStatus(value) {
  return {
    type: setupActionsType.UPDATE_PROGRESSBAR_STATUS,
    value,
  };
}

/**
 * @param {Object} value
 * @param {Number} value.currentVolumeChangesThreshold
 * @param {Object} value.ErrorVolumeChanges
 * @param {Number} value.ErrorVolumeChanges.CurrentChanges
 * @param {Number} value.ErrorVolumeChanges.ErrorType
 * @param {Number} value.ErrorVolumeChanges.Threshold
 * @param {*} value.ErrorVolumeChanges.ThresholdPct
 * @param {Object} value.currentPressureSensors
 * @param {Number} value.currentPressureSensors.0
 * @param {Number} value.currentPressureSensors.1
 * @param {Number} value.currentPressureSensors.2
 * @param {Number} value.currentPressureSensors.3
 * @param {String} value.currentPressure
 * @param {String} value.pumpFlowRate
 * @param {String} value.currentVolume
 * @param {String} value.currentBuffer
 * @param {String} value.estimateConcentration
 * @param {String} value.estSecondsRemaining
 * @param {String} value.secondsElapsed
 * @param {String} value.warningMessage
 * @param {String} value.failureMessage
 * @param {String} value.concentrationFlowRate
 * @param {Object} value.profileRunning
 * @param {String} value.deviceVersion
 * @param {Number} value.profileRunning.Id
 * @param {String} value.profileRunning.Name
 * @param {String} value.profileRunning.CreatedAt
 * @param {String} value.profileRunning.ModifiedAt
 * @param {Object} value.profileRunning.Config
 * @param {Number} value.profileRunning.Config.StartingVolume
 * @param {Number} value.profileRunning.Config.StartingConcentration
 * @param {Number} value.profileRunning.Config.FinalVolume
 * @param {Number} value.profileRunning.Config.EstimatedFinalConcentration
 * @param {Number} value.profileRunning.Config.DiafiltrationMode
 * @param {Number} value.profileRunning.Config.VolumeToStartAt
 * @param {Number} value.profileRunning.Config.BufferVolumeToUse
 * @param {Number} value.profileRunning.Config.TotalBufferVolumeToUse
 * @param {Number} value.profileRunning.Config.OperatingPressure
 * @param {Number} value.profileRunning.Config.RecoveryOfLiquid
 * @param {Number} value.profileRunning.Config.FlowRate
 * @param {Number} value.profileRunning.Config.DiaphragmVacuumPressure
 * @param {Number} value.profileRunning.Config.DiaphragmPressure
 * @param {Number} value.profileRunning.Config.DiaphragmTiming
 * @param {Number} value.profileRunning.Config.ValveTiming
 * @param {Number} value.profileRunning.Config.MembraneCutOffSize
 * @param {Number} value.profileRunning.Config.ConicalVolume
 * @param {Number} value.profileRunning.Config.Notes
 * @param {Number} value.profileRunning.Config.ChipValve
 * @param {Number} value.profileRunning.Config.MoreThan50ml
 * @param {Number} value.profileRunning.Config.StartingVolumeFor2ndTube
 * @param {Number} value.profileRunning.Config.ManualControlThreshold
 * @param {Object} value.advSetupChoosen
 * @param {Number} value.advSetupChoosen.Id
 * @param {String} value.advSetupChoosen.Name
 * @param {String} value.advSetupChoosen.CreatedAt
 * @param {String} value.advSetupChoosen.ModifiedAt
 * @param {Object} value.advSetupChoosen.ConfigAdvSetup
 * @param {Object} value.advSetupChoosen.ConfigAdvSetup.GeneralAdvSetup
 * @param {Number} value.advSetupChoosen.ConfigAdvSetup.GeneralAdvSetup.MembraneFillingCycle
 * @param {Number} value.advSetupChoosen.ConfigAdvSetup.GeneralAdvSetup.SkipPriming
 * @param {Number} value.advSetupChoosen.ConfigAdvSetup.GeneralAdvSetup.ManualControlThreshold
 * @param {Object} value.advSetupChoosen.ConfigAdvSetup.MainAdvSetup
 * @param {Object} value.advSetupChoosen.ConfigAdvSetup.MainAdvSetup.PressureAdvSetup
 * @param {*} value.advSetupChoosen.ConfigAdvSetup.MainAdvSetup.DefaultReturnValvePressure
 * @param {Number} value.advSetupChoosen.ConfigAdvSetup.MainAdvSetup.DiaphragmTiming
 * @param {Number} value.advSetupChoosen.ConfigAdvSetup.MainAdvSetup.ValveTiming
 * @param {Object} value.advSetupChoosen.ConfigAdvSetup.DiafiltrationAdvSetup
 * @param {Object} value.advSetupChoosen.ConfigAdvSetup.DiafiltrationAdvSetup.PressureAdvSetup
 * @param {*} value.advSetupChoosen.ConfigAdvSetup.DiafiltrationAdvSetup.DefaultReturnValvePressure
 * @param {Number} value.advSetupChoosen.ConfigAdvSetup.DiafiltrationAdvSetup.DiaphragmTiming
 * @param {Number} value.advSetupChoosen.ConfigAdvSetup.DiafiltrationAdvSetup.ValveTiming
 * @param {Number} value.advSetupChoosen.ConfigAdvSetup.DiafiltrationAdvSetup.Duration
 * @param {Object} value.advSetupChoosen.ConfigAdvSetup.PrimeAdvSetup
 * @param {Object} value.advSetupChoosen.ConfigAdvSetup.PrimeAdvSetup.PressureAdvSetup
 * @param {*} value.advSetupChoosen.ConfigAdvSetup.PrimeAdvSetup.DefaultReturnValvePressure
 * @param {Number} value.advSetupChoosen.ConfigAdvSetup.PrimeAdvSetup.DiaphragmTiming
 * @param {Number} value.advSetupChoosen.ConfigAdvSetup.PrimeAdvSetup.ValveTiming
 * @param {Number} value.advSetupChoosen.ConfigAdvSetup.PrimeAdvSetup.Duration
 * @param {Object} value.advSetupChoosen.ConfigAdvSetup.RecoveryAdvSetup
 * @param {Object} value.advSetupChoosen.ConfigAdvSetup.RecoveryAdvSetup.PressureAdvSetup
 * @param {*} value.advSetupChoosen.ConfigAdvSetup.RecoveryAdvSetup.DefaultReturnValvePressure
 * @param {Number} value.advSetupChoosen.ConfigAdvSetup.RecoveryAdvSetup.DiaphragmTiming
 * @param {Number} value.advSetupChoosen.ConfigAdvSetup.RecoveryAdvSetup.ValveTiming
 * @param {Number} value.advSetupChoosen.ConfigAdvSetup.RecoveryAdvSetup.Duration
 * @param {Object} value.recoveryOfLiquidStatus
 * @param {ENUM.RECOVERY_OF_LIQUID} value.recoveryOfLiquidStatus.recoveryOfLiquidStatus {@link ENUM.RECOVERY_OF_LIQUID}
 * @param {String} value.recoveryOfLiquidStatus.CurrentRunTime
 * @param {ENUM.RECOVERY_OF_LIQUID} value.recoveryOfLiquidStatus.RecoveryOfLiquidState
 * @param {String} value.recoveryOfLiquidStatus.TotalRunTime
 * @returns
 */
export function updateStatus(value) {
  return {
    type: setupActionsType.UPDATE_STATUS,
    value,
  };
}
export function updateDefaultConfigParams(value) {
  return {
    type: setupActionsType.UPDATE_DEFAULT_CONFIG_PARAMS,
    value,
  };
}
export function updateDefaultConfigAdvSetupParams(value) {
  return {
    type: setupActionsType.UPDATE_DEFAULT_CONFIG_ADV_SETUP_PARAMS,
    value,
  };
}
export function updateDefaultReturnValvePressureParams(value) {
  return {
    type: setupActionsType.UPDATE_DEFAULT_RETURN_VALVE_PRESSURE_PARAMS,
    value,
  };
}
export function updateStoppingFromButton(value) {
  return {
    type: setupActionsType.UPDATE_STOPPING_FROM_BUTTON,
    value,
  };
}
export function updateRefilledBufferVolume(value) {
  return {
    type: setupActionsType.UPDATE_REFILL_BUFFER_VOLUME,
    value,
  };
}
export function updateIsSensorRefillBuffer(value) {
  return {
    type: setupActionsType.IS_UPDATE_SESOR_REFILL_BUFFER,
    value,
  };
}

// TODO: change the updateActiveMenu usage to be used the derived parameters
/**
 * @param {PAGE_MENU} value {@link PAGE_MENU}
 * @returns
 */
export function updateActiveMenu(value) {
  return {
    type: setupActionsType.UPDATE_ACTIVE_MENU,
    value,
  };
}
//-------------------------------------------------------
// Explorer page
//-------------------------------------------------------
export function updateProfileList(value) {
  return {
    type: setupActionsType.UPDATE_PROFILE_LIST,
    value,
  };
}
export function profileSelected(value) {
  return {
    type: setupActionsType.PROFILE_SELECTED,
    value,
  };
}
export function updateProfileName(value) {
  return {
    type: setupActionsType.UPDATE_PROFILE_NAME,
    value,
  };
}
export function profileSettingExplorer(value) {
  return {
    type: setupActionsType.PROFILE_SETTING_EXPLORER,
    value,
  };
}

/**
 * @deprecated redundant between {@link setupActionsType.INIT_VALUE} and {@link setupActionsType.UPDATE_ALL_VALUE}
 * @param {Object}
 */
export function updateAllValue(value) {
  return {
    type: setupActionsType.UPDATE_ALL_VALUE,
    value,
  };
}
export function updateShowProfile(value) {
  return {
    type: setupActionsType.UPDATE_SHOW_PROFILE,
    value,
  };
}
export function setLastProfileIdView(value) {
  return {
    type: setupActionsType.UPDATE_LAST_PROFILE_ID_VIEW,
    value,
  };
}
export function setProfileList(value) {
  return {
    type: setupActionsType.SET_PROFILE_LIST,
    value,
  };
}
export function resetPreviewProfile(value) {
  return {
    type: setupActionsType.RESET_PREVIEW_PROFILE,
    value,
  };
}
export function saveProfile(value) {
  return {
    type: setupActionsType.SAVE_PROFILE,
    value,
  };
}
export function setInvalidAutoProfileParams(value) {
  return {
    type: setupActionsType.SET_INVALID_AUTO_PROFILE_PARAMS,
    value,
  };
}
export function updateCurrentProfileParam(value) {
  return {
    type: setupActionsType.UPDATE_CURRENT_PROFILE_PARAM,
    value,
  };
}
export function templateNewProfile(value) {
  return {
    type: setupActionsType.TEMPLATE_NEW_PROFILE,
    value,
  };
}
//------------------------------------------------------
// Auto Profile page
//------------------------------------------------------
export function isCompleteFill(value) {
  return {
    type: setupActionsType.COMPLETE_PROFILE_FILL,
    value,
  };
}
// export function isShowRecoveryLoading(value) {
// 	return {
// 		type: setupActionsType.SHOW_RECOVERY_LOADING,
// 		value: value,
// 	};
// }

/**
 * @param {Boolean} value
 * @returns
 */
export function isFinishRecovery(value) {
  return {
    type: setupActionsType.IS_FINISH_RECOVERY,
    value,
  };
}
export function updateRecoveryStatus(value) {
  return {
    type: setupActionsType.UPDATE_RECOVERY_STATUS,
    value,
  };
}
export function updateAutoProfileSetupMode(value) {
  return {
    type: setupActionsType.UPDATE_AUTO_PROFILE_SETUP_MODE,
    value,
  };
}
export function updateAutoProfileDiafiltrationMode(value) {
  return {
    type: setupActionsType.UPDATE_AUTO_PROFILE_DIAFILTRATION_MODE,
    value,
  };
}

//-------------------------------------------------------
// Advanced Setup Explorer page
//-------------------------------------------------------
export function updateAdvSetupList(value) {
  return {
    type: setupActionsType.UPDATE_ADV_SETUP_LIST,
    value,
  };
}
export function setAdvSetupSelected(value) {
  return {
    type: setupActionsType.ADV_SETUP_SELECTED,
    value,
  };
}
export function updateAdvSetupName(value) {
  return {
    type: setupActionsType.UPDATE_ADV_SETUP_NAME,
    value,
  };
}
export function advSetupSettingExplorer(value) {
  return {
    type: setupActionsType.ADV_SETUP_SETTING_EXPLORER,
    value,
  };
}
export function advSetupAllValue(value) {
  return {
    type: setupActionsType.UPDATE_ALL_VALUE_ADV_SETUP,
    value,
  };
}
export function updateShowAdvSetup(value) {
  return {
    type: setupActionsType.UPDATE_SHOW_ADV_SETUP,
    value,
  };
}
export function setLastAdvSetupIdView(value) {
  return {
    type: setupActionsType.UPDATE_LAST_ADV_SETUP_ID_VIEW,
    value,
  };
}
export function setLastAdvSetupIdCreated(value) {
  return {
    type: setupActionsType.UPDATE_LAST_ADV_SETUP_ID_CREATED,
    value,
  };
}
export function setAdvSetupList(value) {
  return {
    type: setupActionsType.SET_ADV_SETUP_LIST,
    value,
  };
}
export function resetPreviewAdvSetup(value) {
  return {
    type: setupActionsType.RESET_PREVIEW_ADV_SETUP,
    value,
  };
}
export function setSaveAdvSetup(value) {
  return {
    type: setupActionsType.SAVE_ADV_SETUP,
    value,
  };
}
export function setButtonClickedTypeAdv(value) {
  return {
    type: setupActionsType.SET_BUTTON_TYPE_ADV,
    value,
  };
}
export function updateCurrentAdvSetupParam(value) {
  return {
    type: setupActionsType.UPDATE_CURRENT_ADV_SETUP_PARAM,
    value,
  };
}
export function setTemplateNewAdvSetup(value) {
  return {
    type: setupActionsType.TEMPLATE_NEW_ADV_SETUP,
    value,
  };
}
export function setEditAdvSetup(value) {
  return {
    type: setupActionsType.EDIT_ADV_SETUP,
    value,
  };
}
export function setDisableSaveSetupButton(value) {
  return {
    type: setupActionsType.DISABLE_SAVE_SETUP_BUTTON,
    value,
  };
}

/**
 *
 * @param {Object} value
 * @param {Boolean} value.alertShow
 * @param {String} value.alertText
 * @param {String} value.alertStyle
 * @returns
 */
export function showAlert(value) {
  return {
    type: setupActionsType.SHOW_ALERT,
    value,
  };
}
// export function showLoading(value) {
// 	return {
// 		type: setupActionsType.SHOW_LOADING,
// 		value: value,
// 	};
// }
// export function updateLoading(value) {
// 	return {
// 		type: setupActionsType.UPDATE_LOADING,
// 		value: value,
// 	};
// }
// save setting
export function saveCycleThreshold(value) {
  return {
    type: setupActionsType.SAVE_CYCLE_THRESHOLD,
    value,
  };
}
/**
 * Enable/Disable modify a profile (Edit/Delete)
 * Set True => enable modify profile
 * Set False => disable modify profile
 * @param {Boolean} value
 */
export function modifyProfile(value) {
  return {
    type: setupActionsType.MODIFY_PROFILE,
    value,
  };
}
export function modifyAdvSetup(value) {
  return {
    type: setupActionsType.MODIFY_ADV_SETUP,
    value,
  };
}
// info and support
export function updateFontSize(value) {
  return {
    type: setupActionsType.UPDATE_FONT_SIZE,
    value,
  };
}
// usbfile update
/**
 * @deprecated
 * @param {Boolean} value
 * @returns
 */
export function isOpenFile(value) {
  return {
    type: setupActionsType.IS_OPEN_FILE,
    value,
  };
}
export function usbProperties(value) {
  return {
    type: setupActionsType.USB_PROPERTIES,
    value,
  };
}
export function usbOpenFor(value) {
  return {
    type: setupActionsType.USB_OPEN_FOR,
    value,
  };
}

/**
 * @param {*} value
 * @returns
 */
export function selectedFileUpdate(value) {
  return {
    type: setupActionsType.SELECTED_FILE_UPDATE,
    value,
  };
}
export function selectedFileExport(value) {
  return {
    type: setupActionsType.SELECTED_FILE_EXPORT,
    value,
  };
}
export function selectedDateBeginExport(value) {
  return {
    type: setupActionsType.SELECTED_DATE_BEGIN_EXPORT,
    value,
  };
}
export function selectedDateEndExport(value) {
  return {
    type: setupActionsType.SELECTED_DATE_END_EXPORT,
    value,
  };
}
export function selectedFolderExportDestination(value) {
  return {
    type: setupActionsType.SELECTED_FOLDER_EXPORT_DESTINATION,
    value,
  };
}
export function expandAccordionStatus(value) {
  return {
    type: setupActionsType.EXPAND_ACCORDION_STATUS,
    value,
  };
}

// wizard action
// TODO: need to be careful with this method since the setter can be set from any place and the UI will generated on certain places, the wizard state can be stored as local state on a container component to define which content should be displayed
export function nextActionWizard(value) {
  return {
    type: setupActionsType.NEXT_ACTION_WIZARD,
    value,
  };
}

// TODO: need to be careful with this method since the setter can be set from any place and the UI will generated on certain places, the wizard state can be stored as local state on a container component to define which content should be displayed
export function prevActionWizard(value) {
  return {
    type: setupActionsType.PREV_ACTION_WIZARD,
    value,
  };
}

// cleaning wizard
/**
 * Sample Structure of Cleaning Properties
 */
export const CleaningProperties = {
  isCleaningWizardRunning: false,
  cleaningDuration: undefined,
  cleaningSolution: 25,
  valveChipType: 6,
  [KEY.MembraneCutOffSize]: undefined,
  [KEY.ConicalVolume]: undefined,
};

/**
 * @param {CleaningProperties} value
 * @returns
 */
export function setCleaningProperties(_value) {
  const value = {..._value};
  if (value.MembraneCutOffSize && !IsNumber(value.MembraneCutOffSize))
    value.MembraneCutOffSize = parseInt(value.MembraneCutOffSize, 10);
  return {
    type: setupActionsType.SET_CLEANING_PROPERTIES,
    value,
  };
}

// top Menu
export function backButtonProperties(value) {
  return {
    type: setupActionsType.BACK_BUTTON_PROPERTIES,
    value,
  };
}
export function topButtonProperties(value) {
  return {
    type: setupActionsType.TOP_BUTTON_PROPERTIES,
    value,
  };
}

/**
 * @param {Boolean} value
 * @returns
 */
export function updateLockAccess(value) {
  return {
    type: setupActionsType.UPDATE_LOCK_ACESS,
    value,
  };
}
export function topButtonSecondaryProperties(value) {
  return {
    type: setupActionsType.TOP_BUTTON_SECONDARY_PROPERTIES,
    value,
  };
}
export function topButtonTertiaryProperties(value) {
  return {
    type: setupActionsType.TOP_BUTTON_TERTIARY_PROPERTIES,
    value,
  };
}
export function setTitleMenuProperties(value) {
  return {
    type: setupActionsType.SET_TITLE_MENU_PROPERTIES,
    value,
  };
}
// Top Button back action
export function setTopMenuProperties(value) {
  return {
    type: setupActionsType.SET_TOP_MENU_PROPERTIES,
    value,
  };
}
export function setDoubleTopMenuProperties(value) {
  return {
    type: setupActionsType.SET_DOUBLE_TOP_MENU_PROPERTIES,
    value,
  };
}
export function updateMessageAutoProfileHelpParam(value) {
  return {
    type: setupActionsType.UPDATE_MESSAGE_AUTO_PROFILE_HELP,
    value,
  };
}
// Pressure Param
export function updateDefaultHighPressureParam(value) {
  return {
    type: setupActionsType.UPDATE_DEFAULT_HIGH_PRESSURE_PARAM,
    value,
  };
}
export function updateDefaultLowPressureParam(value) {
  return {
    type: setupActionsType.UPDATE_DEFAULT_LOW_PRESSURE_PARAM,
    value,
  };
}
export function updateDefaultHighSequenceParam(value) {
  return {
    type: setupActionsType.UPDATE_DEFAULT_HIGH_SEQUENCE_PARAM,
    value,
  };
}
export function updateDefaultLowSequenceParam(value) {
  return {
    type: setupActionsType.UPDATE_DEFAULT_LOW_SEQUENCE_PARAM,
    value,
  };
}
export function updateDefaultPressureTemplate(value) {
  return {
    type: setupActionsType.UPDATE_DEFAULT_PRESSURE_TEMPLATE,
    value,
  };
}

/**
 * Sample DefaultSequenceTemplate Property
 */
export const DefaultSequenceTemplate = {
  Id: '-1', // ignore compare
  Sequence: 'prime', // ignore to compare
  Repeat: 7,
  Active: true,
  Running: false,
  SequenceParams: {
    Hi: {
      [KEY.DiaphragmTimingOpen]: '275',
      [KEY.DiaphragmTimingClose]: '275',
      [KEY.ValveTiming]: '25',
    },
    Lo: {
      [KEY.DiaphragmTimingOpen]: '500',
      [KEY.DiaphragmTimingClose]: '500',
      [KEY.ValveTiming]: '50',
    },
  },
  PressureState: {
    PressureType: PRESSURE_TYPE.LO,
    PressureConfig: {
      Hi: [50, -9.25, 40, 15],
      Lo: [30, -9, 10, 18],
    },
  },
  RepeatType: RUN_TIME_MODE.TIMES.VALUE,
  TempRepeat: 1,
};

/**
 * @param {DefaultSequenceTemplate} value
 * @returns
 */
export function updateDefaultSequenceTemplate(value) {
  return {
    type: setupActionsType.UPDATE_DEFAULT_SEQUENCE_TEMPLATE,
    value,
  };
}
export function updateCurrentIsMoreThan50ml(value) {
  return {
    type: setupActionsType.UPDATE_CURRENT_IS_MORE_THAN_50_ML,
    value,
  };
}

/**
 * @deprecated current state of wifi status will be handled by the derived context
 * @param {WIFI_STATUS} value
 * @returns
 */
export function updateWifiStatus(value) {
  return {
    type: setupActionsType.UPDATE_WIFI_STATUS,
    value,
  };
}

/**
 * @deprecated current state of wifi list will be handled by the derived context
 * @param {Array} value
 * @returns
 */
export function updateWifiList(value) {
  return {
    type: setupActionsType.UPDATE_WIFI_LIST,
    value,
  };
}

/**
 * @deprecated current state of connected wifi will be handled by the derived context
 * @param {Object} value
 * @returns
 */
export function wifiConnected(value) {
  return {
    type: setupActionsType.SET_CURRENT_WIFI_CONNECTED,
    value,
  };
}

/**
 * @deprecated current state of connected wifi will be handled by the derived context
 * @param {Object} value
 * @returns
 */
export function updateWifi(value) {
  return {
    type: setupActionsType.UPDATE_WIFI,
    value,
  };
}

/**
 * @deprecated the reducer has been moved into {@link deviceStore}
 * @param {Boolean} value
 * @returns
 */
export function isShuttingdown(value) {
  return {
    type: setupActionsType.IS_SHUTTINGDOWN,
    value,
  };
}

/**
 * @param {*} value
 * @returns
 */
export const SetErrorParams = (value) => ({
  type: setupActionsType.ERROR_PARAMS,
  value,
});

/**
 * @param {Boolean} value
 * @returns
 */
export const SetCycleFinishStatus = (value) => ({
  type: setupActionsType.CYCLE_FINISH,
  value,
});

/**
 * Sample Operation Property
 */
export const Operation = {
  Active: true,
  Id: -1,
  PressureState: null,
  Repeat: 1,
  RepeatType: '0',
  Repeated: 0,
  Running: false,
  Sequence: 'pressure_changes',
  SequenceParams: {TargetPressure: [30, -11.375, 10, 5], PressureType: 'Lo'},
  TimeElapsed: 0,
};

/**
 * @param {Object} value
 * @returns
 */
export const SetCustomOperation = (value) => ({
  type: setupActionsType.CUSTOM_OPERATION.SET,
  value,
});

/**
 * @param {Array.<Operation>} value
 * @returns
 */
export const UpdateOperationList = (value) => ({
  type: setupActionsType.CUSTOM_OPERATION.OPERATION_LIST,
  value,
});

/**
 * @param {Array.<Operation>} value
 * @returns
 */
export const UpdateTempOperationList = (value) => ({
  type: setupActionsType.CUSTOM_OPERATION.TEMP_OPERATION_LIST,
  value,
});

/**
 * @param {String} value
 * @returns
 */
export const SetCustomOperationName = (value) => ({
  type: setupActionsType.CUSTOM_OPERATION.NAME,
  value,
});

/**
 * @param {String} value
 * @returns
 */
export const SetCustomOperationFileName = (value) => ({
  type: setupActionsType.CUSTOM_OPERATION.FILE_NAME,
  value,
});

/**
 * @param {Boolean} value
 * @returns
 */
export const SetCustomOperationContentChanged = (value) => ({
  type: setupActionsType.CUSTOM_OPERATION.CONTENT_CHANGED,
  value,
});

/**
 * @param {Boolean} value
 * @returns
 */
export const SetCustomOperationDepressurizingAtTheEnd = (value) => ({
  type: setupActionsType.CUSTOM_OPERATION.IS_DEPRESSURIZED_AT_THE_END,
  value,
});

/**
 * @param {Number} value
 * @returns
 */
export const SetCustomOperationRepeatValue = (_value) => {
  let value = _value;
  if (!IsNumber(value)) value = parseInt(value, 10);
  return {
    type: setupActionsType.CUSTOM_OPERATION.REPEAT,
    value,
  };
};

/**
 * @param {Number} value
 * @returns
 */
export const SetCustomOperationRepeatedValue = (_value) => {
  let value = _value;
  if (!IsNumber(value)) value = parseInt(value, 10);
  return {
    type: setupActionsType.CUSTOM_OPERATION.REPEATED,
    value,
  };
};

/**
 * @param {Number} value
 * @returns
 */
export const SetDefaultPrimeParam = (value) => ({
  type: setupActionsType.CUSTOM_OPERATION.DEFAULT_PRIME_PARAM,
  value,
});

/**
 * @param {DEVICE_STATE} value {@link DEVICE_STATE}
 * @returns
 */
export const SetCustomOperationStatus = (value) => ({
  type: setupActionsType.CUSTOM_OPERATION.STATUS,
  value,
});

/**
 * @param {String} value
 * @returns
 */
export const SetCustomOperationMessage = (value) => ({
  type: setupActionsType.CUSTOM_OPERATION.MESSAGE,
  value,
});

/**
 * @param {Number} value
 * @returns
 */
export const SetCustomOperationTimeElapsed = (_value) => {
  let value = _value;
  if (!IsNumber(value)) value = parseInt(value, 10);
  return {
    type: setupActionsType.CUSTOM_OPERATION.TIME_ELAPSED,
    value,
  };
};

/**
 * @param {Number} value
 * @returns
 */
export const SetCustomOperationPreloaded = (value) => ({
  type: setupActionsType.CUSTOM_OPERATION.PRELOADED,
  value,
});

/**
 * @param {Object} value
 * @returns
 */
export const SetCleaningCustomOperation = (value) => ({
  type: setupActionsType.CLEANING_CUSTOM_OPERATION.SET,
  value,
});

/**
 * @param {Array.<Operation>} value
 * @returns
 */
export const UpdateCleaningOperationList = (value) => ({
  type: setupActionsType.CLEANING_CUSTOM_OPERATION.OPERATION_LIST,
  value,
});

/**
 * @param {Array.<Operation>} value
 * @returns
 */
export const UpdateCleaningTempOperationList = (value) => ({
  type: setupActionsType.CLEANING_CUSTOM_OPERATION.TEMP_OPERATION_LIST,
  value,
});

/**
 * @param {String} value
 * @returns
 */
export const SetCleaningCustomOperationName = (value) => ({
  type: setupActionsType.CLEANING_CUSTOM_OPERATION.NAME,
  value,
});

/**
 * @param {Boolean} value
 * @returns
 */
export const SetCleaningCustomOperationDepressurizingAtTheEnd = (value) => ({
  type: setupActionsType.CLEANING_CUSTOM_OPERATION.IS_DEPRESSURIZED_AT_THE_END,
  value,
});

/**
 * @param {Number} value
 * @returns
 */
export const SetCleaningCustomOperationRepeatValue = (_value) => {
  let value = _value;
  if (!IsNumber(value)) value = parseInt(value, 10);
  return {
    type: setupActionsType.CLEANING_CUSTOM_OPERATION.REPEAT,
    value,
  };
};

/**
 * @param {Number} value
 * @returns
 */
export const SetCleaningCustomOperationRepeatedValue = (_value) => {
  let value = _value;
  if (!IsNumber(value)) value = parseInt(value, 10);
  return {
    type: setupActionsType.CLEANING_CUSTOM_OPERATION.REPEATED,
    value,
  };
};

/**
 * @param {Number} value
 * @returns
 */
export const SetCleaningDefaultPrimeParam = (value) => ({
  type: setupActionsType.CLEANING_CUSTOM_OPERATION.DEFAULT_PRIME_PARAM,
  value,
});

/**
 * @param {DEVICE_STATE} value {@link DEVICE_STATE}
 * @returns
 */
export const SetCleaningCustomOperationStatus = (value) => ({
  type: setupActionsType.CLEANING_CUSTOM_OPERATION.STATUS,
  value,
});

/**
 * @param {String} value
 * @returns
 */
export const SetCleaningCustomOperationMessage = (value) => ({
  type: setupActionsType.CLEANING_CUSTOM_OPERATION.MESSAGE,
  value,
});

/**
 * @param {Number} value
 * @returns
 */
export const SetCleaningCustomOperationTimeElapsed = (_value) => {
  let value = _value;
  if (!IsNumber(value)) value = parseInt(value, 10);
  return {
    type: setupActionsType.CLEANING_CUSTOM_OPERATION.TIME_ELAPSED,
    value,
  };
};

export function IsFromStopProfile(value) {
  return {
    type: setupActionsType.IS_STOP_FROM_PROFILE,
    value,
  };
}

export function IsRecoveryFromErrorProfile(value) {
  return {
    type: setupActionsType.IS_RECOVERY_FROM_ERROR_PROFILE,
    value,
  };
}

export function IsRecoveryClicked(value) {
  return {
    type: setupActionsType.IS_RECOVERY_CLICKED,
    value,
  };
}

export function IsRecalibration(value) {
  return {
    type: setupActionsType.IS_RECALIBRATION,
    value,
  };
}

export function setProfileRunning(value) {
  return {
    type: setupActionsType.SET_PROFILE_RUNNING,
    value,
  };
}

export function setCurrentBuffer(value) {
  return {
    type: setupActionsType.SET_CURRENT_BUFFER,
    value,
  };
}

export function setCurrentVolume(value) {
  return {
    type: setupActionsType.SET_CURRENT_VOLUME,
    value,
  };
}

export function setRequireRefill(value) {
  return {
    type: setupActionsType.SET_REQUIRE_REFILL,
    value,
  };
}

export function setDisabledTopButtonProp(value) {
  return {
    type: setupActionsType.SET_DISABLED_TOP_BUTTON_PROPERTIES,
    value,
  };
}
